<template>
  <q-dialog v-model="abrirModal" persistent>
    <q-card style="width: 900px; max-width: 95vw">
      <q-card-section class="row items-center">
        <div class="text-h6">
          Notificações
          <span v-if="notificacaoUsuarioAlvo" class="text-subtitle2 text-grey-7">
            — {{ notificacaoUsuarioAlvo.nome }}
          </span>
        </div>
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup @click="fechar" />
      </q-card-section>

      <q-separator />

      <q-card-section v-if="notificacoesPreferenciasLoading" class="text-center q-pa-lg">
        <q-spinner color="primary" size="2em" />
      </q-card-section>

      <q-card-section v-else style="max-height: 60vh" class="scroll">
        <div class="text-caption text-grey-7 q-mb-sm">
          Escolha quais eventos geram notificação para este usuário.
        </div>

        <q-item v-ripple class="row justify-between items-center q-px-none">
          <q-item-section avatar>
            <q-icon name="mail" color="primary" size="22px" />
          </q-item-section>

          <q-item-section>
            <q-item-label>Receber também por e-mail</q-item-label>
            <q-item-label v-if="emailDoAlvo" caption>
              Envia para {{ emailDoAlvo }} um resumo dos eventos marcados abaixo, além do
              aviso na tela
            </q-item-label>
            <q-item-label v-else caption class="text-orange">
              Este usuário não tem e-mail cadastrado
            </q-item-label>
          </q-item-section>

          <q-item-section side>
            <q-toggle
              color="green"
              checked-icon="check"
              unchecked-icon="clear"
              :label="emailAtivo ? 'Sim' : 'Não'"
              :model-value="emailAtivo"
              :disable="!emailDoAlvo"
              @update:model-value="alternarEmail"
            />
          </q-item-section>
        </q-item>

        <q-separator spaced />

        <q-list>
          <div v-for="(tipos, grupo) in tiposPorGrupo" :key="grupo">
            <q-separator spaced v-if="grupo !== primeiroGrupo" />

            <q-item-label>
              <span><strong>{{ grupo }}</strong></span>
              <q-toggle
                color="green"
                label="Sim para todos"
                checked-icon="check"
                unchecked-icon="clear"
                :model-value="grupoTodoAtivo(tipos)"
                :disable="!grupoTemConfiguravel(tipos)"
                @update:model-value="(v) => alternarGrupo(tipos, v)"
              />
            </q-item-label>

            <q-item
              v-ripple
              class="row justify-between items-center"
              v-for="tipo in tipos"
              :key="tipo.id"
            >
              <q-item-section avatar>
                <q-icon
                  :name="tipo.icone || 'notifications'"
                  :color="corDaSeveridade(tipo.severidade)"
                  size="22px"
                />
              </q-item-section>

              <q-item-section>
                <q-item-label>
                  {{ tipo.label }}
                  <q-badge
                    v-if="!tipo.permite_desativar"
                    color="grey-6"
                    class="q-ml-sm"
                    label="Sempre ativo"
                  />
                </q-item-label>
                <q-item-label caption>{{ tipo.descricao }}</q-item-label>
              </q-item-section>

              <q-item-section side>
                <q-toggle
                  color="green"
                  checked-icon="check"
                  unchecked-icon="clear"
                  :label="valorDe(tipo) ? 'Sim' : 'Não'"
                  :model-value="valorDe(tipo)"
                  :disable="!tipo.permite_desativar"
                  @update:model-value="(v) => alternar(tipo, v)"
                />
              </q-item-section>
            </q-item>
          </div>
        </q-list>
      </q-card-section>

      <q-separator />

      <q-card-actions align="right">
        <q-btn flat label="Cancelar" color="grey-8" v-close-popup @click="fechar" />
        <q-btn
          color="primary"
          no-caps
          label="Salvar"
          id="btn-salvar-notificacoes-usuario"
          :loading="notificacoesPreferenciasSalvando"
          :disable="notificacoesPreferenciasLoading"
          @click="salvar()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapGetters } from "vuex";

const CORES_SEVERIDADE = {
  info: "blue",
  aviso: "orange",
  erro: "red",
};

export default {
  name: "modal-notificacoes-usuario",

  computed: {
    ...mapGetters([
      "notificacoesTipos",
      "notificacoesPreferencias",
      "notificacoesEmailAtivo",
      "notificacaoUsuarioAlvo",
      "notificacoesPreferenciasLoading",
      "notificacoesPreferenciasSalvando",
      "OpenDialogNotificacoesUsuario",
    ]),

    emailAtivo() {
      return this.notificacoesEmailAtivo === true;
    },

    // usuário sem e-mail cadastrado não tem para onde receber
    emailDoAlvo() {
      return (this.notificacaoUsuarioAlvo && this.notificacaoUsuarioAlvo.email) || "";
    },

    abrirModal: {
      get() {
        return this.OpenDialogNotificacoesUsuario;
      },
      set(valor) {
        this.$store.commit("OpenDialogNotificacoesUsuario", valor);
      },
    },

    tiposPorGrupo() {
      const porGrupo = {};

      this.notificacoesTipos.forEach((tipo) => {
        if (!porGrupo[tipo.grupo]) {
          porGrupo[tipo.grupo] = [];
        }
        porGrupo[tipo.grupo].push(tipo);
      });

      return porGrupo;
    },

    primeiroGrupo() {
      return Object.keys(this.tiposPorGrupo)[0];
    },
  },

  methods: {
    corDaSeveridade(severidade) {
      return CORES_SEVERIDADE[severidade] || "grey-7";
    },

    // tipo obrigatório aparece sempre marcado: é o que o usuário de fato recebe
    valorDe(tipo) {
      if (!tipo.permite_desativar) return true;

      return this.notificacoesPreferencias[tipo.id] === true;
    },

    alternarEmail(ativo) {
      this.$store.commit("SET_NOTIFICACOES_EMAIL_ATIVO", ativo);
    },

    alternar(tipo, ativo) {
      if (!tipo.permite_desativar) return;

      this.$store.commit("TOGGLE_NOTIFICACAO_PREFERENCIA", {
        tipoId: tipo.id,
        ativo: ativo,
      });
    },

    grupoTemConfiguravel(tipos) {
      return tipos.some((tipo) => tipo.permite_desativar);
    },

    grupoTodoAtivo(tipos) {
      const configuraveis = tipos.filter((tipo) => tipo.permite_desativar);

      // grupo só com tipo obrigatório (Sistema): tudo nele já está ativo e não há o que
      // desligar, então o toggle tem que aparecer ligado em vez de sugerir o contrário
      if (configuraveis.length === 0) return true;

      return configuraveis.every((tipo) => this.valorDe(tipo));
    },

    alternarGrupo(tipos, ativo) {
      tipos.forEach((tipo) => this.alternar(tipo, ativo));
    },

    fechar() {
      this.$store.commit("OpenDialogNotificacoesUsuario", false);
    },

    async salvar() {
      const ok = await this.$store.dispatch("salvarNotificacoesPreferencias");

      this.$q.notify({
        message: ok
          ? "Preferências de notificação salvas."
          : "Não foi possível salvar as preferências.",
        color: ok ? "green" : "red",
        position: "top-right",
      });
    },
  },
};
</script>
